<div
  [class.uploader-disabled]="isDisabled()"
  [attr.aria-disabled]="isDisabled()"
>
  <neo-uploader
    #neoUploader
    [style]="effectiveUploaderStyle()"
    [extensions]="acceptedFileTypes()"
    [maxSizeBytes]="maxFileSize() * 1024 * 1024"
    [maxFileSizeMB]="maxFileSize()"
    [maxFiles]="maxFiles()"
    [disabled]="isDisabled()"
    [hideFileContainer]="isFileContainerHidden()"
    [attr.aut-id]="autId()"
    (afterFileAddedToQueue)="onFileAddedToQueue($any($event))"
    (removedFile)="onFileRemovedFromQueue($any($event))"
    (extensionError)="onExtensionError($any($event))"
    (sizeError)="onSizeError($any($event))"
    (minSizeError)="onSizeError($any($event))"
    (onUploadFail)="onUploadFail()"
  >
  </neo-uploader>

  @if (showsAttachmentList()) {
    @if (attachments().length > 0) {
      <ul class="uploader__attachments" [attr.aut-id]="autId() + '-attachments'">
        @for (attachment of attachments(); track attachment.id) {
          <li>
            <cm-attachment-list-item
              [attachment]="attachment"
              [canDelete]="showsDeleteAction()"
              [deleting]="deletingAttachmentId() === attachment.id"
              (download)="attachmentDownload.emit($event)"
              (delete)="attachmentDelete.emit($event)"
            />
          </li>
        }
      </ul>
    } @else if (showsEmptyText()) {
      <p class="uploader__empty">{{ emptyText() }}</p>
    }
  }

  @if (showsQueue() && queuedFiles().length > 0) {
    <ul class="uploader__queue" [attr.aut-id]="autId() + '-queue'">
      @for (file of queuedFiles(); track file.name) {
        <li class="uploader__queue-item">
          <cm-icon name="attach_file" size="s" aria-hidden="true" />
          <div class="uploader__queue-file-info">
            <span class="uploader__queue-name">{{ file.name }}</span>
            <span class="uploader__queue-size">{{ (file.size / 1024 / 1024).toFixed(2) }} MB</span>
          </div>
          <cm-button
            class="uploader__queue-remove-btn"
            variant="basic"
            color="gray"
            [iconOnly]="true"
            ariaLabel="Remove {{ file.name }}"
            (click)="onQueueRemove(file)"
          >
            <cm-icon name="close" size="s" aria-hidden="true" />
          </cm-button>
        </li>
      }
    </ul>
  }

  <div class="uploader__error" role="alert" [attr.aut-id]="autId() + '-error'">
    @if (errorMessage()) {
      {{ errorMessage() }}
    }
  </div>
</div>
